function geotargetly_loaded() {
  var geocountrycode = sessionStorage.getItem('geolocationcode');
  var country_code = geocountrycode;

  if (geocountrycode == null) {
    var country_name = geotargetly_country_name();
    var region_code = geotargetly_region_code();
    var state_name = geotargetly_region_name();
    country_code = geotargetly_country_code();
    var city_name = geotargetly_city_name();
    var lat = geotargetly_lat();
    var lng = geotargetly_lng();
    var ip = geotargetly_ip();
    sessionStorage.setItem('geolocationcode', country_code);
  }

  console.log('You are in ', country_code);

}

if (sessionStorage.getItem('geolocationcode') != null) {
  geotargetly_loaded();
}
